export default __webpack_public_path__ + "static/media/SourceSansProRegular.cc642343.ttf";